import { render } from "./PlotBillingModal.vue?vue&type=template&id=965038fc&scoped=true"
import script from "./PlotBillingModal.vue?vue&type=script&lang=js"
export * from "./PlotBillingModal.vue?vue&type=script&lang=js"

import "./PlotBillingModal.vue?vue&type=style&index=0&id=965038fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965038fc"]])

export default __exports__